import { Component } from '@angular/core';

@Component({
  selector: 'stars-elements-platforms',
  templateUrl: './elements-platforms.html',
  styleUrls: ['./elements-platforms.scss']
})
export class ElementsPlatformsComponent {}
